import { OnInit, Directive } from '@angular/core';
import '../../assets/scripts/funnel.js';
import { environment } from '../../environments/environment';

declare var stepCallback: any;

@Directive()
export abstract class RegistrationStep implements OnInit {
  public static get FIRST_STEP() {
    return { funnelStep: 1, gtmStep: 1 };
  }
  public static get CONFIRMATION_STEP() {
    return { funnelStep: 2, gtmStep: 99 };
  }
  public static get SECOND_STEP() {
    return { funnelStep: 3, gtmStep: 2 };
  }
  public static get THIRD_STEP() {
    return { funnelStep: 4, gtmStep: 3 };
  }
  public static get FOURTH_STEP() {
    return { funnelStep: 5, gtmStep: 4 };
  }
  public static get FIFTH_STEP() {
    return { funnelStep: 6, gtmStep: 5 };
  }
  public static get FIRST_STEPS() {
    return { funnelStep: 1 };
  }

  public stepNumber: any;
  public gtmStepNumber: any;
  public brand: any;

  ngOnInit() {
    stepCallback(this.stepNumber, this.brand);
  }

  constructor(stepNumber: any) {
    this.stepNumber = stepNumber['funnelStep'];
    this.gtmStepNumber = stepNumber['gtmStep'];
    this.brand = environment.brand;
  }
}
